export default __webpack_public_path__ + "static/hp-brand-deck-03-71c314b29b7dbf1aa5bd1e10502f2d9c.png";